import React, { useEffect, useState } from 'react'
import { MoContainer, MoSpan, Button, Alert, ButtonTypes } from '../../Mo7/mo7UI'
import { cols } from '../../services/design.sevice';
import { database } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { SUBSCRIPTION_STATES } from "../../services/data.service"
import { useTrail } from '@react-spring/core';
import { animated } from '@react-spring/web';
export default function Notifications() {

    const [announcements, setAnnouncements] = useState([])
    // const [subscriptionRequests, setSubscriptionRequests] = useState([])
    // const [viewAnnouncement, setViewAnnouncement] = useState(false)
    // const [displayedAnn, setDisplayedAnn] = useState({})
    const { currentUser } = useAuth()
    useEffect(() => {
        //get from database
        return database.announcements.where("uid", "==", currentUser.uid)
            .orderBy('groupChatLabel')
            .onSnapshot(snapshot => {
                setAnnouncements(snapshot.docs.map(database.formattedDoc))

            })

    }, [currentUser.uid])


    async function handleAcceptSubscription(uid, announcement_id, subscription_state) {
        try {
            //get doccumet 
            await database.announcements.doc(announcement_id).update({
                [`subscribers.${uid}.state`]: subscription_state
            })
        } catch (er) {
            console.log(er)

        }
    }
    const anim_subs = useTrail(announcements.length, {
        from: {
            opacity: 0,
            x: -50
        },
        to: {

            opacity: 1,
            x: 0
        }
    })
    const domAnnouncementsSubscritionRequists = announcements.map((ele, i) => {
        return <animated.div style={anim_subs[i]}> <MoContainer m_r="auto" wrap="wrap" key={i} min_w="28rem" flex >
            {Object.entries(ele.subscribers).map((r, j) => {
                return r[1].state !== SUBSCRIPTION_STATES.BANNED && <MoContainer wrap="wrap" key={j} flex gap="1rem" align="center">
                    <MoContainer eff_size={{ val: 1.2 }} bg_i="https://firebasestorage.googleapis.com/v0/b/sfe-tutor-bolt.appspot.com/o/img_profile_picture.jpg?alt=media&token=79fa179b-c6ac-4518-be62-5030047f3610" border={{ w: "2px", col: cols.main_purple }} b_r={{ all: "12rem" }} wh="2.5rem" />
                    <MoSpan fs_sml  > {r[1].displayName}</MoSpan>
                    {r[1].state === SUBSCRIPTION_STATES.ACCEPTED
                        ? <>
                            <MoSpan fs_sml col={cols.green} > Accepted </MoSpan>
                            <Button title="Reject" onClick={function () { handleAcceptSubscription(r[0], ele.id, SUBSCRIPTION_STATES.REJECTED) }} type={ButtonTypes.dangerOutline} pd={{ ub: "10px", lr: "20px" }} />
                        </>
                        : <>
                            <MoSpan fs_sml col={cols.red} > Rejected </MoSpan>
                            <Button title="Accept" onClick={function () { handleAcceptSubscription(r[0], ele.id, SUBSCRIPTION_STATES.ACCEPTED) }} type={ButtonTypes.success} pd={{ ub: "10px", lr: "20px" }} />
                        </>}
                    <Alert disabled>{ele.groupChatLabel}</Alert>
                </MoContainer>
            })}
        </MoContainer></animated.div>
    })

    return (
        <MoContainer pos="relative">
            {/* Header */}
            <MoContainer h="5rem" flex align="center">
                <MoSpan fs_mid m_r="auto" m_l="auto"> Notifications </MoSpan>
            </MoContainer>

            <MoContainer grid tem_c="1fr 1fr">
                <MoContainer flex_c align="center">
                    <Alert info > Requests 👇</Alert>

                    <MoContainer flex_c w="100%" h="50vh" pd={{ tb: '2rem', lr: 0 }} scroller={{ col: "#eee" }} flow_y="scroll" align="center">
                        {/* announcements container */}
                        <MoContainer w="100%" flex_c align="center">
                            {/* announcements */}

                            {domAnnouncementsSubscritionRequists}
                        </MoContainer>

                    </MoContainer>

                </MoContainer>
                <MoContainer flex_c align="center">
                    <Alert info > General 👇</Alert>


                </MoContainer>



            </MoContainer>

        </MoContainer>
    )
}
